import {makeStyles} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    bgImage: {
        display: 'block',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: 'contain',
        width: '100%',
        height: '100%'
    },
    xxxSmall: {
        height: '0.8rem',
        width: '0.8rem'
    },
    xxSmall: {
        height: theme.spacing(4),
        width: theme.spacing(4)
    },
    xSmall: {
        height: theme.spacing(5),
        width: theme.spacing(5)
    },
    small: {
        height: theme.spacing(7),
        width: theme.spacing(7)
    },
    medium: {
        height: theme.spacing(8),
        width: theme.spacing(8)
    },
    large: {
        height: theme.spacing(12),
        width: theme.spacing(12)
    },
    xLarge: {
        height: theme.spacing(16),
        width: theme.spacing(16)
    },
    wrapper: {
        cursor: 'pointer',
        display: 'inline-block'
    },
    horizontal: {
        transform: 'scaleX(-1)'
    }
}));

export default useStyles;
